<script>
  import Header from "./Header.svelte";
  import Modal from "./Modal.svelte";
  import Users from "./Admin/Users.svelte";
  import { usersStore } from "./store/users.js";
  import { countryStore } from "./store/countries.js";
  import { Router, Link, Route, navigate } from "svelte-routing";
  import { slide, blur, fade, fly } from "svelte/transition";
  import { setContext as baseSetContext } from "svelte";
  import * as util from "./js/util.js";

  import Countries from "./Admin/Countries.svelte";
  import CountryDetail from "./Admin/CountryDetail.svelte";
  import EditCountryVersion from "./Admin/EditCountryVersion.svelte";
  import LanguageTexts from "./Admin/LanguageTexts.svelte";
  import LanguageTextEdit from "./Admin/LanguageTextEdit.svelte";
  import Langs from "./Admin/Langs.svelte";
  import UserDetail from "./Admin/UserDetail.svelte";

  export let setContext = baseSetContext;
  export let url = "";
  let visible = true;

  var myurl = window.location.href.replace(window.location.origin, "");
  if (myurl == "" || myurl == "app" || myurl == "/") {
    navigate("/app/countries");
  }
  let showInfoMessage = false;
  let msgIsSuccess = false;
  countryStore.getCountries();
  let infoMessage;

  const snackbar = (type, message) => {
    infoMessage = message;
    if (type == "error") {
      msgIsSuccess = false;
    } else {
      msgIsSuccess = true;
    }
    showInfoMessage = true;
    window.setTimeout(() => (showInfoMessage = false), 3000);
  };

  async function init() {
    setTimeout(async () => {
      var user = await usersStore.getLoggedInUser();
      if (user.loggedIn == false) {
        return;
      } else loggedIn = true;
    }, 30);
  }
  init();

  let loggedIn = false;
  window.showLoginScreen = () => {
    loggedIn = false;
  };

  async function login() {
    var ret = await usersStore.login(userName, password);
    if (ret.success) {
      loggedIn = true;
    } else {
      alert("bad login");
    }
  }

  let userName = "wkd";
  let password = "wkd";
  setContext("app", { snackbar });
</script>

{#if !loggedIn}
<!-- 
  <input class="test" id="username" type="text" bind:value={userName} />
  username

  <br />
  <input id="password" type="password" bind:value={password} />
  password
  <br />
  <input type="button" on:click={login} value="login" /> -->
<div style="max-width:500px; margin: 100px auto">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">LOGIN</h5>
  </div>
  <div class="modal-body">
    <label for="naam">Username</label>
    <input
      id="username" 
      type="text" 
      bind:value={userName} 
      class="form-control"
      placeholder="username"
    />
    <label for="password">Password</label>
    <input
      id="password" 
      type="password" 
      bind:value={password}
      class="form-control"
      placeholder="Fill in password only if you want to change it"
      />
    <br />
  </div>
  <div class="modal-footer">
    <input type="button" class="btn btn-primary" on:click={login} value="login" />
  </div>
</div>
{:else}
  <Modal closeOnOuterClick={false}>
    <main>
      <Header />
      {#if showInfoMessage}
        {#if msgIsSuccess}
          <div
            class="alert alert-success"
            style="position:fixed;top:73px;left:1px;width:100%;z-index:1000"
            role="alert"
            transition:fade
          >
            <button aria-label="" class="close" data-dismiss="alert" />
            <strong>Information:</strong>
            {@html infoMessage}
          </div>
        {:else}
          <div
            class="alert alert-danger"
            style="position:fixed;top:70px;left:1px;width:100%;z-index:1000"
            role="alert"
            transition:fade
          >
            <button aria-label="" class="close" data-dismiss="alert" />
            <strong>Error:</strong>
            {@html infoMessage}
          </div>
        {/if}
      {/if}
      <div class="p-5">
        <div class="row">
          <div class="col-12">
            <Router {url}>
              <Route path="/app/countries" component={Countries} />
              <Route path="/app/countries/:id" component={CountryDetail} />
              <Route
                path="/app/countryversion/:id"
                component={EditCountryVersion}
              />
              <Route path="/app/langs/" component={Langs} />
              <Route path="/app/langtexts/" component={LanguageTexts} />
              <Route path="/app/langtexts/:id" component={LanguageTextEdit} />
              <Route path="/app/users/" component={Users} />
              <Route path="/app/users/:id" component={UserDetail} />
            </Router>
          </div>
        </div>
      </div>
    </main>
  </Modal>
{/if}

<style>
  .test {
    border: 1px solid green;
  }
</style>
